import React from 'react';
import { useCurrency, CurrencyCode } from '../../contexts/CurrencyContext';

interface CurrencyDisplayProps {
  amount: number;
  currency?: string; // Optional currency override
  className?: string;
  showConversion?: boolean; // Whether to show conversion to other currencies
}

const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({
  amount,
  currency,
  className = '',
}) => {
  const { state, convertAmount, formatCurrency } = useCurrency();

  // Format the amount. Assume incoming amount is in DZD (the base currency of projects)
  // If a specific currency override is provided, use that, otherwise use the user's selected currency.
  const targetCurrency = (currency as CurrencyCode) || state.selectedCurrency;

  // Convert from DZD to target currency
  const convertedAmount = convertAmount(amount, 'DZD', targetCurrency);
  const formattedAmount = formatCurrency(convertedAmount, targetCurrency);

  return (
    <span className={className}>
      {formattedAmount}
    </span>
  );
};

export default CurrencyDisplay;